export default __webpack_public_path__ + "static/media/miguel-lopes-22.d9267c3a.jpg";